import React, { Component } from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import isEqual from 'lodash/isEqual';

// GLOBAL FUNCTIONS
import { doCallback } from 'functions';

// LOCAL COMPONENTS
import Input from './Input';

// STYLES
import styles from './customInput.module.scss';

// MAIN COMPONENT
class CustomInput extends Component {
  constructor(props) {
    super(props);

    this.input = React.createRef();

    this.state = {
      inputValue: props.selectProps.value[0]?.label || '',
      selectValue: props.selectProps.value[0] || ''
    };
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(this.props.selectProps.value[0], prevProps.selectProps.value[0])) {
      this.setState({
        inputValue: this.props.selectProps.value[0]?.label || '',
        selectValue: this.props.selectProps.value[0] || ''
      })
    }
  }

  handleFocus = e => {
    doCallback(this.props.onFocus, e);
  }

  handleBlur = e => {
    const { inputValue, selectValue } = this.state;
    doCallback(this.props.onBlur, e);
    if (inputValue !== selectValue.label && inputValue !== '') { // blank values are updated by handleChange
      doCallback(this.props.selectOption, {
        label: inputValue,
        value: inputValue
      })
    }
  }

  handleKeyDown = e => {
    if (e.target.value.length > 0) {
      e.stopPropagation(); // important: this will allow the use of backspace in the input
    }
  }
  
  handleChange = e => {
    e.stopPropagation();
    doCallback(this.props.onChange, e);
    if (e.target.value === '') {
      doCallback(this.props.setValue({
        label: '',
        value: ''
      }));
      doCallback(this.props.onFocus, e);
    }
    this.setState({
      inputValue: e.target.value
    })
  }

  // RENDER
  render() {
    const { inputValue } = this.state;
    return (
      <Input
        {...this.props}
        className={clsx(
          'custom-input',
          styles.customInput
        )}
        value={inputValue}
        placeholder={this.props.placeholder}
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
        onChange={this.handleChange}
        onKeyDown={this.handleKeyDown}
        ref={this.input}
      />
    )
  }
}

// EXPORT
export default CustomInput;